<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    :fill="strokeColor" 
    :class="svgClass"
    viewBox="0 0 16 16"
  >
   <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
  </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['stroke', 'iconClass'])

const strokeColor = computed(() => {
  return props.stroke ? props.stroke : 'black'
})

const svgClass = computed(() => {
  return props.iconClass ? props.iconClass : 'w-5 h-5'
})
</script>
